import { render, staticRenderFns } from "./BaseForgetPwd.vue?vue&type=template&id=5a7c9219&scoped=true"
import script from "./BaseForgetPwd.vue?vue&type=script&lang=js"
export * from "./BaseForgetPwd.vue?vue&type=script&lang=js"
import style0 from "./BaseForgetPwd.vue?vue&type=style&index=0&id=5a7c9219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7c9219",
  null
  
)

export default component.exports